import { render, staticRenderFns } from "./websitePrice.vue?vue&type=template&id=42cfa684"
import script from "./websitePrice.vue?vue&type=script&lang=js"
export * from "./websitePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports